<ws-modal-wrapper headerLabel="Activity Details"
                  [hideFooter]="true"
                  (cancel)="cancel()">
    <parcel-activity-summary [siteId]="params.siteId" [showComplianceInfo]="true"></parcel-activity-summary>
</ws-modal-wrapper>
